export enum FuelDeliveryVerificationStatus {
  Verified = 1,
  Short = 2,
  Unverified = 3,
}

export enum FuelClaimStatus {
  Open = 1,
  Settled = 2,
  Rejected = 3,
}

export enum FuelDispenseMethod {
  Machine = 1,
  Drum = 2,
}

export enum FuelDispenseAuthStatus {
  Authorized = 1,
  Unauthorized = 2,
}

export enum FuelDispenseDataQualityFlag {
  MissingSmu = 1,
}

export enum FuelDrawerClass {
  HaulTrucksMobilePlant = 1,
  LightVehicles = 2,
  DrumsStaticPlant = 3,
}

export enum FuelDrumStatus {
  Open = 1,
  Closed = 2,
}

export enum FuelLossCaseStatus {
  Open = 1,
  PendingApproval = 2,
  Closed = 3,
}

export enum FuelLossOutcome {
  Recovered = 1,
  WrittenOff = 2,
  Disciplinary = 3,
}

export enum FuelLossSeverity {
  Critical = 1,
  Warning = 2,
}

export enum FuelTankClass {
  Static = 1,
  Bowser = 2,
}

export enum FuelTransferLineDirection {
  TransferIn = 1,
  TransferOut = 2,
}

export enum FuelReconStatus {
  Draft = 1,
  SignedOff = 2,
}

export enum FuelCalibrationResult {
  Pass = 1,
  Fail = 2,
}

export enum FuelAlertKind {
  UnauthorizedDraw = 1,
  ShortDelivery = 2,
  CalibrationOverdue = 3,
  OverBandBurn = 4,
  UnexplainedDrop = 5,
  SensorOffline = 6,
  ExcessDispense = 7,
  MissingSmu = 8,
}

export enum FuelAlertLatency {
  Live = 1,
  NextFill = 2,
}

export enum FuelDeliveryFuelType {
  Diesel = 1,
  Benzine = 2,
  Gas = 3,
}

export enum FuelDeliveryRequestStatus {
  Requested = 1,
  InProcurement = 2,
  PartiallyReceived = 3,
  Received = 4,
  PartiallyFulfilled = 5,
  Fulfilled = 6,
  Cancelled = 7,
}

export enum FuelDataMode {
  Manual = 1,
  Telemetry = 2,
}

export enum FuelMachineAnalyticsClass {
  OperatedMobile = 1,
  StaticPlant = 2,
}

export enum FuelRateProvenance {
  Measured = 1,
  BetweenFills = 2,
  Attributed = 3,
}
